import { combineReducers } from 'redux'
import address from './address'
import application from './application'
import card from './card'
import classifiedCardData from './classifiedCardData'
import common from './common'
import funding from './funding'
import lockPanel from './lockPanel'
import ui from '../features/ui/ui-slice'
import changeAddress from '../features/change-address/change-address-slice'
import fundingInstruments from '../features/funding-instruments/funding-instruments-slice.js'
import replaceCard from '../features/replace-card/replace-card-slice'
import activateCard from '../features/activate-card/activate-card-slice'
import enrollCard from '../features/enroll-card/enroll-card-slice'
import setPin from '../features/set-pin/set-pin-slice'
import manageCard from '../features/manage-card/manage-card-slice'
import showCard from '../features/show-card/show-card-slice'
import lowBalanceAlert from '../features/low-balance-alert/low-balance-alert-slice'
import requestPhysicalCard from '../features/request-physical-card/request-physical-card-slice'

const reducers = {
  common,
  card,
  classifiedCardData,
  address,
  application,
  funding,
  lockPanel,
  // New flow reducers
  ui,
  changeAddress,
  replaceCard,
  activateCard,
  enrollCard,
  setPin,
  manageCard,
  showCard,
  lowBalanceAlert,
  requestPhysicalCard,
  fundingInstruments
}

const otherStateVarsWithoutReducers = [
  'eligibility',
  'returnUri',
  'entryPoint',
  'step',
  'requestedProducts',
  'isMobileNative',
  'experiments',
  'flfr',
  'src',
]

export const REDUCER_STATE_NAMES = Object.keys(reducers).concat(otherStateVarsWithoutReducers)

const passThroughReducersForStateVars = otherStateVarsWithoutReducers.reduce(
  (acc, cur) => ({ ...acc, [cur]: (state = null) => state }),
  {},
)

const rootReducer = combineReducers({
  ...reducers,
  ...passThroughReducersForStateVars,
})

export default rootReducer
